import { render } from "./IconLibrary.vue?vue&type=template&id=ef410908"
import script from "./IconLibrary.vue?vue&type=script&lang=js"
export * from "./IconLibrary.vue?vue&type=script&lang=js"

import "./IconLibrary.vue?vue&type=style&index=0&id=ef410908&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__